import de from './de';
import en from './en';
import en_GB from './en_GB';
import es from './es';
import fr from './fr';
import ja from './ja';
import it from './it';

export { de, en, en_GB, es, fr, ja, it };



// WEBPACK FOOTER //
// ./src/translations/index.js